/**
 *
 * @module drmManagerConfiguration
 *
 */

import ServiceConfiguration from './serviceConfiguration';

/**
 *
 * @class DrmManagerConfiguration
 *
 */
export default class DrmManagerConfiguration extends ServiceConfiguration {}



// WEBPACK FOOTER //
// ./src/services/configuration/drmManagerConfiguration.js